module.exports = __webpack_public_path__ + "static/crema_sloik@0,5x-0d772c6cf314a29d03f001d257c469a4.png";